/** Governed Field Lock — fields owned by KYC Readiness → Company Master are read-only in consumer modules. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Lock } from "lucide-react";

const MASTER_TAB = { company: "master", id: "GST", bank: "BANK_ACCOUNT", signatory: "SIGNATORY", contact: "CONTACT" };

export function useGovernedFields(collection) {
  const [gov, setGov] = useState({});
  useEffect(() => { api.get("/kyc-engine/sot/governed-fields").then(({ data }) => { const m = data?.[collection] || {}; setGov(Object.fromEntries(Object.entries(m).map(([mk, field]) => [field, mk]))); }).catch(() => {}); }, [collection]);
  return gov;
}

export const masterLink = (masterKey) => `/compliance/kyc/readiness?tab=${MASTER_TAB[(masterKey || "").split(".")[0]] || "master"}&field=${masterKey}`;

export function GovernedTag({ masterKey, testid }) {
  return <Link to={masterLink(masterKey)} className="inline-flex items-center gap-1 rounded border border-emerald-200 bg-emerald-50 px-1.5 py-0.5 text-[9px] font-semibold text-emerald-800 hover:bg-emerald-100" title={`Governed by Company Master · ${masterKey}`} data-testid={testid}><Lock className="h-2.5 w-2.5" />Managed in KYC Readiness</Link>;
}

export function GovernedBanner({ count, testid }) {
  if (!count) return null;
  return <div className="flex flex-wrap items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-[11px] text-emerald-900" data-testid={testid}><Lock className="h-3.5 w-3.5" /><b>{count} field(s) are governed by the KYC Readiness Company Master</b> — they are read-only here and update automatically. <Link to="/compliance/kyc/readiness?tab=master" className="underline">Edit in KYC Readiness →</Link></div>;
}
